module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-11@2x-f4688d1aa2d036f1e2588405da23823b.png";